var render = function render(){var _vm=this,_c=_vm._self._c;return _c('filtered-search-bar',{key:_vm.filteredSearchKey,staticClass:"gl-w-full",attrs:{"namespace":"","terms-as-tokens":"","show-friendly-text":"","tokens":_vm.tokens,"search-input-placeholder":_vm.$options.i18n.search,"initial-filter-value":_vm.getFilteredSearchValue},on:{"on-filter":_vm.handleFilter}})
}
var staticRenderFns = []

export { render, staticRenderFns }